import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { TabbedPage, Tab } from 'components/Shared/TabbedPage';
import FloatingActionButton from 'components/Shared/FloatingActionButton'; 
import AddContractors from 'components/Contractors/AddContractors';
import ContractorsGrid from 'components/Contractors/ContractorsGrid';
import {FormProvider } from 'context/FormContext';
import AuthCheck from 'components/Shared/AuthCheck';
const tabs = [
  new Tab({label: "Contractors", value: "ContractorsGrid", scope: "Contractors", action: "read"}),
  new Tab({label: "Add Contractor", value: "addContractors", scope: "Contractors", action: "create"})
]

const Contractors = () => {
  const [activeTab, setActiveTab] = useState("ContractorsGrid");

  return (
    <FormProvider>
    <TabbedPage
      tabs={tabs}
      activeTab={activeTab}
      tabSetterFunc={setActiveTab}
    >
    {(() => {
        switch (activeTab) {
          case "ContractorsGrid": return <ContractorsGrid />;
          case "addContractors": return <AddContractors  CRUDType="INSERT" callback={() => {setActiveTab("ContractorsGrid")}} />;
          default: return <ContractorsGrid />;
        }
      })()}   

    <AuthCheck scope="Contractors" action="create"><FloatingActionButton onClick={() => setActiveTab("addContractors")}><AddIcon /></FloatingActionButton></AuthCheck>

    </TabbedPage>
    </FormProvider>
  )
}

export default Contractors;